import type { BulkEvaluationResponse } from '@/types/material/bulk-check';
import { PsHttpService, type PatSnapCommonResponseData } from '@patsnap/tahiti-core/common/ps-http';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';

@injectable()
export class MaterialBulkApiImpl extends PsHttpService implements MaterialBulkApi {
    get options() {
        return {
            baseURL: `${import.meta.env.VITE_EUREKA_SERVICE_URI}/eureka/material/bulk-check`,
            headers: {
                'X-API-Version': '1.0',
            },
        };
    }

    getEvaluationData(agent_job_id: string, doc_id: string) {
        return this.post<PatSnapCommonResponseData<BulkEvaluationResponse>>({
            url: '/get-data',
            data: {
                agent_job_id,
                doc_id,
            },
        }).then(res => {
            return res.data as BulkEvaluationResponse
        })
    }
}

export const MaterialBulkApi = Symbol('MaterialBulkApi');

export interface MaterialBulkApi {
    getEvaluationData(agent_job_id: string, doc_id: string): Promise<BulkEvaluationResponse>;
}
